import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common/common.service';
import { HeadersService } from '../header.service';

@Injectable({
  providedIn: 'root'
})
export class TempoDeEsperaService {
  private readonly url = `${environment.apiUrl}/api/v1/tempo-espera`;

  constructor(
    private readonly http: HttpClient,
    private commonService: CommonService,
    private headersService: HeadersService
  ) {
    this.headersService.includeObject({ fileName: 'tempo-de-espera.service.ts', url: this.url });
  }

  public get(time: number): Observable<any> {
    let param = this.commonService.getParameters({
      tempo: time
    });
    return this.http.get<any>(`${this.url}${param}`).pipe(map((response) => response));
  }
}
